const filterByRiskLevel = ({score, riskLevel}) =>
  riskLevel === 'high'
    ? score >= 75.5
    : riskLevel === 'medium'
    ? score < 75.5 && score >= 35.5
    : score < 35.5;

export default filterByRiskLevel;
